<template>
  <div>
      <b-form novalidate @submit.prevent="onSubmit">
          <b-row>
              <b-col xs="12" md="6">
                  <b-card class="mt-3">
                      <h4 slot="header">Collection Details</h4>
                      <text-control label="Station Name" v-model="item.station.name" disabled></text-control>
                      <text-control label="Station City" v-model="item.station.displayCity" disabled></text-control>
                      <text-control label="Date" v-model="item.date" disabled></text-control>
                  </b-card>
                  <b-card-group class="mt-3">
                      <b-card v-for="category in categories" v-bind:key="category.name" class="text-center">
                          <template v-slot:header>
                              <h4>
                                  {{category.displayName}}
                                  <!-- <span class="small"><b-badge pill :variant="getCategorySettings(item.station, item, category).backgroundColor">{{getCategorySettings(item.station, item, category).shortLabel}}</b-badge></span> -->
                              </h4>
                          </template>
                          <b-card-text>
                              <div>{{getCategorySettings(item.station, item, category).label}}</div>
                          </b-card-text>
                          <template v-slot:footer>
                              <div class="text-center">
                                  <gauge-widget :value="getCategorySettings(item.station, item, category).gaugeValue" />
                                  <div class="gauge-widget-sub-value">
                                      <span v-if="getCategorySettings(item.station, item, category).rawValue !== null">
                                          {{getCategorySettings(item.station, item, category).rawValue}}
                                      </span>
                                  </div>
                              </div>
                          </template>
                      </b-card>
                  </b-card-group>
              </b-col>
              <b-col xs="12" md="6">
                  <b-card class="mt-3">
                      <h4 slot="header">Comments</h4>
                      <textarea-control label="Weather Notes" v-model="item.weatherNotes"></textarea-control>
                      <textarea-control label="Comment" v-model="item.comment"></textarea-control>
                      <checkbox-control label="Show Comment Publicly" description="If checked, end users will see this comment." v-model="item.isCommentPublic"></checkbox-control>
                  </b-card>
              </b-col>
          </b-row>

          <b-row class="mt-3">
              <b-col>
                  <hr />
                  <p>Counts are entered as particles per cubic meter. Click the button below display additional columns of information.</p>

                  <filtered-table v-if="item" :settings="tableSettings" :staticItems="item.station.stationAllergens">
                      <template v-slot:image="data">
                          <img class="allergen-image" :src="'/images/' + data.item.allergen.imageName" :alt="data.item.allergen.name" @click="showAllergenImageModal(data.item)" />
                      </template>
                      <template v-slot:value="data">
                          <b-input-group>
                              <b-input class="allergen-collection-value" v-model="getAllergenCollection(data.item.allergen.id).value" type="number" lazy-formatter :formatter="formatInt"></b-input>
                              <b-input-group-append>
                                  <b-input-group-text>
                                      /m<sup>3</sup>
                                  </b-input-group-text>
                              </b-input-group-append>
                          </b-input-group>
                      </template>
                      <template v-slot:level="data">
                          {{getLevel(data.item.allergen)}}
                      </template>
                  </filtered-table>

              </b-col>
          </b-row>
          <!-- Send Notification Emails checkbox -->
          <b-form-checkbox v-if="item && !item.notificationsSent" v-model="sendNotifications">Send Notification Emails <span style="color:red">(subscribers will only be sent notification of this count if the box is checked)</span></b-form-checkbox>
          <b-row class="mt-3">
              <b-col>
                  <b-button-toolbar key-nav>
                      <b-button-group>
                          <b-button type="submit" variant="primary">
                              <slot name="save"></slot>
                          </b-button>
                      </b-button-group>
                      <b-button-group class="mx-2">
                          <b-button type="button" @click="onCancel">Cancel</b-button>
                      </b-button-group>
                  </b-button-toolbar>
              </b-col>
          </b-row>

      </b-form>

    <b-modal id="allergenImageModal" :title="modal.title" ok-only>
      <p class="text-center">
        <img :src="modal.image" />
      </p>
    </b-modal>
  </div>
</template>

<script>
import AllergenCollectionMixins from '../Common/AllergenCollectionMixins.js'

export default {
  name: "AllergenCollectionSetFields",
  mixins: [
    AllergenCollectionMixins,
  ],
  props: [
      'item'
  ],
  data() {
    return {
      tableSettings: {
          defaultSortColumn: 'allergen.category',
        defaultSortOrder: 'asc',
        columns: [
          {
            key: 'allergen.id',
            name: 'ID',
            alwaysLoad: true,
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'image',
            name: 'Image',
              visible: false,
            sortable: false
          },
          {
            key: 'value',
            name: 'Value',
            visible: true,
            sortable: false
          },
          {
            key: 'level',
            name: 'Level',
              visible: false,
            sortable: false
          },
          {
            key: 'allergen.category',
            name: 'Category',
            visible: true,
            sortable: true,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'AllPollen', text: 'All Pollen', filter: x => x.allergen.category != 'MOLD' },
              { value: 'GRASS', text: 'Grass' },
              { value: 'MOLD', text: 'Mold' },
              { value: 'TREE', text: 'Tree' },
              { value: 'WEED', text: 'Weed' },
              { value: 'UNIDENTIFIED', text: 'Unidentified' }
            ]
          },
          {
            key: 'allergen.name',
            name: 'Scientific Name',
              visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'allergen.family',
            name: 'Family',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'allergen.commonName',
            name: 'Common Name',
              visible: true,
            sortable: true,
            filter: 'text'
          }
        ]
      },
      modal: {
        title: null,
        image: null
      }
    };
  },
  methods: {
    formatInt(value) {
      if (value == '')
        return '';
      let x = value;
      return Math.round(x, 0);
    },
    getAllergenCollection(allergenId) {
      let x = this.item.allergenCollections.find(x => x.allergen.id == allergenId);
      return x;
    },
    getLevel(allergen) {
      let scale = this.item.station.scaleSet.scales.find(x => x.category == allergen.category);
      if (!scale)
        return 'No Scale';
      let value = this.getAllergenCollection(allergen.id).value;
      if (isNaN(parseInt(value)))
          return 'Not Counted';
      else if (value >= scale.range4Begin)
        return 'Very High';
      else if (value >= scale.range3Begin)
        return 'High';
      else if (value >= scale.range2Begin)
        return 'Moderate';
      else if (value > scale.range1Begin)
            return 'Low';
      else if (value == 0)
          return 'Not Present';
    },
    onCancel() {
      this.$emit('cancel');
    },
    onSubmit() {
      // Make sure all the child components are valid
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; }))
        this.$emit('submit');
    },
    showAllergenImageModal(item) {
      this.modal.image = '/images/' + item.allergen.imageName;
      this.modal.title = item.allergen.name + ' ' + item.allergen.family;
      this.$bvModal.show('allergenImageModal');
    }
  }
};
</script>